import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    templateUrl: 'dialog.component.html',
    standalone: false
})
export class DialogComponent {
    confirmationChecked = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
        public dialogRef: MatDialogRef<DialogComponent>,
    ) {
    }

    ok(): void {
        this.dialogRef.close(true);
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}

export interface DialogData {
    // badge is treated like a type of textual icon
    // if both badge and icon are provided, icon is ignored
    // todo: add badge style
    badge?: string;
    icon?: string;
    title?: string;
    // todo DEVCOID-1736: subtitle and subtitleHtml are both optional, and when both are set the markup branch silently wins.
    // DEVCOID-1736 drops the markup input entirely; if it lands on a compromise, constrain the pair in the type instead.
    subtitle?: string;
    // rendered through [innerHtml]: the key and every translationParams value reach the DOM unsanitized.
    // The key MUST be an i18n constant; any runtime value in translationParams MUST be escaped by the caller.
    subtitleHtml?: string;
    buttonOkText?: string;
    confirmationText?: string;
    buttonCancelText?: string;
    isButtonOkAccent?: boolean;
    translationParams?: Record<string, string>;
    commonsClickById?: Record<string, any>,
}
